import { useEffect, useState } from 'preact/hooks'
import useStepRequest from '../Hooks/useStepRequest'
import styles from './RepeatConfirmCode.module.css'

const TIMER_DURATION = 1000

const RepeatConfirmCode = () => {
  const { step1 } = useStepRequest()

  const [showBtn, setShowBtn] = useState(null)
  const [counter, setCounter] = useState(600)

  useEffect(() => {
    if (counter === 0) {
      setShowBtn(true)
    }
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), TIMER_DURATION)
    return () => clearInterval(timer)
  }, [counter])

  const handlerRepeatCode = () => {
    step1()
    setShowBtn(false)
    setCounter(600)
  }

  return (
    <div className={styles.wrapper}>
      {showBtn ? (
        <span className={styles.repeat} onClick={handlerRepeatCode}>
          Запросить код повторно
        </span>
      ) : (
        <span>
          Запросить код повторно можно через <span>{counter}</span> секунд
        </span>
      )}
    </div>
  )
}

export default RepeatConfirmCode
